// extracted by mini-css-extract-plugin
module.exports = {"sidebarNav":"DocumentationSidebar_sidebarNav__2DFU3","collapsibleTrigger":"DocumentationSidebar_collapsibleTrigger__1Igml"};